import api from "../api";

const register = async (name, phone, password, verificationCode) => {
  const requestData = {
    "name": name,
    "phone": phone,
    "password": password,
    "verification_code": verificationCode
  }

  try {

    const response = await api.post(process.env.REACT_APP_API_ENDPOINT + "/api/user/register", requestData);
    return response.data;
  } catch (error) {
    console.error('There was a problem with the axios operation:', error);
    throw error;
  }

}

export default register;
